export interface SavedTextTemplate {
  id: string;
  title: string;
  body: string;
  createdAt: string;
}

const SAVED_TEXTS_STORAGE_KEY_LEGACY = 'campaign-saved-texts-v1';
const SAVED_TEXTS_STORAGE_KEY_PREFIX = 'campaign-saved-texts-v2';

export const DEFAULT_SAVED_TEXTS: SavedTextTemplate[] = [
  {
    id: 'default-contato-inicial',
    title: 'Modelo 1 - Modelo de Contato Inicial',
    body: `Bom dia!

Neste número falo com {{nome}}?

Sou oficial de justiça (documento abaixo) e me encontro com um mandado de Citação/Intimação destinado a(o) senhor(a).

A legislação nos autoriza realizar esse ato por meio virtual (WhatsApp), porém, preciso de uma foto de documento pessoal, caso concorde em receber por aqui.

Não havendo concordância, o mandado será cumprido presencialmente no(s) endereço(s) do mandado.

Obs.: Após a identificação da identidade de {{nome}} enviarei o mandado em até uma hora.`,
    createdAt: new Date(0).toISOString()
  },
  {
    id: 'default-reenvio-sem-resposta',
    title: 'Modelo 2 - Reenvio por não resposta',
    body: `Bom dia!

Conforme me identifiquei anteriormente, sou Oficial de Justiça, meu nome é XXXX - matrícula xxxx - e me encontro com um mandado de *intimação/citação* destinado a {{nome}}.

*Neste número falo ou não com essa pessoa?*

Destinatário: {{nome}}.`,
    createdAt: new Date(0).toISOString()
  }
];

const safeStorageSegment = (value?: string | null) => {
  if (!value) return 'none';
  return value.replace(/[^a-zA-Z0-9_-]/g, '_');
};

const decodeTokenPayload = (token: string) => {
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const decoded = atob(padded);
    return JSON.parse(decoded);
  } catch {
    return null;
  }
};

export const buildSavedTextsStorageKey = (params: {
  userId?: string | null;
  tenantId?: string | null;
  token?: string | null;
}) => {
  const tokenPayload = params.token ? decodeTokenPayload(params.token) : null;
  const userId = params.userId || tokenPayload?.id || tokenPayload?.userId || tokenPayload?.sub || 'anonymous';
  const tenantId =
    params.tenantId ||
    tokenPayload?.tenantId ||
    localStorage.getItem('selected_tenant_id') ||
    localStorage.getItem('superadmin_selected_tenant') ||
    'none';

  return `${SAVED_TEXTS_STORAGE_KEY_PREFIX}:${safeStorageSegment(tenantId)}:${safeStorageSegment(userId)}`;
};

export const loadSavedTextTemplates = (params: {
  userId?: string | null;
  tenantId?: string | null;
  token?: string | null;
}) => {
  const storageKey = buildSavedTextsStorageKey(params);
  const raw = localStorage.getItem(storageKey);
  const legacyRaw = localStorage.getItem(SAVED_TEXTS_STORAGE_KEY_LEGACY);
  const sourceRaw = raw ?? legacyRaw;

  if (!sourceRaw) {
    return DEFAULT_SAVED_TEXTS;
  }

  try {
    const parsed = JSON.parse(sourceRaw);
    if (Array.isArray(parsed) && parsed.length > 0) {
      return parsed as SavedTextTemplate[];
    }
  } catch {
    return DEFAULT_SAVED_TEXTS;
  }

  return DEFAULT_SAVED_TEXTS;
};
